import { useEffect, useState } from "react";
import { getAllRoutes, getAllRoutesByCompany } from "../../services";
import { SaleRoute } from "../../types/sale-route.type";

/**
 * The routes a note may be numbered under. A branch picker lists the picked branch's routes
 * (nothing until one is picked); a branch user lists their own. The SPECIAL route is included:
 * special-order bills are corrected by notes too.
 */
export function useNoteRoutes(canSelectBranch: boolean, companyId: string | undefined) {
  const [routes, setRoutes] = useState<SaleRoute[]>([]);

  useEffect(() => {
    if (canSelectBranch && !companyId) {
      setRoutes([]);
      return;
    }
    let active = true;
    (async () => {
      try {
        const {
          data: { data },
        } = canSelectBranch
          ? await getAllRoutes(companyId, { includeSpecial: true })
          : await getAllRoutesByCompany({ includeSpecial: true });
        if (active) setRoutes(Array.isArray(data) ? data : data?.rows ?? []);
      } catch {
        // The interceptor already shows why the routes could not be read.
        if (active) setRoutes([]);
      }
    })();
    return () => {
      active = false;
    };
  }, [canSelectBranch, companyId]);

  return routes;
}
